import React from "react";

export const LessonDataContext = React.createContext<{
  teacherId: number | string;
  subjectId: number | string;
  lessonId: string | number;
  lessonName: string;
} | null>(null);
